<template>
  <router-link v-if="!this.link.includes('http') && text !== ''" tag="button" :to="{ name: this.link, params: { details: this.row, draftId: resolvedDraftId, eventId: resolvedEventId, edit, split, placeholder, slug, tab, id } }" class="btn btn-sm btn-primary mb-2 mb-lg-0 px-lg-3 px-xl-4">
    {{text}}
  </router-link>
  <a :href="this.link" v-else-if="text !== ''" class="btn btn-sm btn-primary mb-2 mb-lg-0" target="_blank" rel="noreferrer">{{text}}</a>
</template>

<script>
export default {
  props: {
    row: Object,
    text: String,
    link: String,
    split: Boolean,
    edit: Boolean,
    placeholder: String,
    slug: {
      default: '',
      required: false
    },
    tab: {
      default: '',
      required: false
    },
    draftId: {
      default: null,
      required: false
    },
    id: {
      default: undefined,
      required: false
    }
  },
  computed: {
    resolvedDraftId() {
      if (this.draftId !== null && this.draftId !== undefined) {
        return this.draftId
      }
      if (this.link === 'Events') {
        return this.row.id
      }
      if (this.link === 'Create Event') {
        return this.row.draft_id
      }
      return undefined
    },
    resolvedEventId() {
      return this.link === 'Create Event' ? this.row.id : undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Button.vue